const currentYear = new Date().getFullYear();

// months are indxed from 0.
// countdown starts on 25 oct of current year
const countdownStart = Date.UTC(currentYear, 9, 25, 0, 0, 0, 0);
// crowdfunding opens at 04:00 UTC (00:00 Ithaca) on 1 nov
const countdownOpen = Date.UTC(currentYear, 10, 1, 0, 0, 0);
// crowdfunding closes at 4:00 UTC (00:00 Ithaca) on 5 dec
const countdownClose = Date.UTC(currentYear, 11, 5, 5, 0, 0);

const countdownMenuBanner = document.createElement('li');
countdownMenuBanner.id = 'countdown-menu-banner';

const countdownMenuTitle = document.createElement('strong');
countdownMenuTitle.id = 'countdown-menu-title';
countdownMenuBanner.append(countdownMenuTitle);

const countdownMenuTimer = document.createElement('div');
countdownMenuTimer.id = 'countdown-menu-timer';
countdownMenuBanner.append(countdownMenuTimer);

const countdownMenuDays = document.createElement('span');
countdownMenuDays.classList.add('countdown-part');
const countdownMenuHours = document.createElement('span');
countdownMenuHours.classList.add('countdown-part');
const countdownMenuMinutes = document.createElement('span');
countdownMenuMinutes.classList.add('countdown-part');
const countdownMenuSeconds = document.createElement('span');
countdownMenuSeconds.classList.add('countdown-part');

const countdownMenuDaysValue = document.createElement('span');
countdownMenuDaysValue.classList.add('countdown-value');
const countdownMenuHoursValue = document.createElement('span');
countdownMenuHoursValue.classList.add('countdown-value');
const countdownMenuMinutesValue = document.createElement('span');
countdownMenuMinutesValue.classList.add('countdown-value');
const countdownMenuSecondsValue = document.createElement('span');
countdownMenuSecondsValue.classList.add('countdown-value');

const countdownMenuDaysUnit = document.createElement('span');
countdownMenuDaysUnit.classList.add('countdown-unit');
const countdownMenuHoursUnit = document.createElement('span');
countdownMenuHoursUnit.classList.add('countdown-unit');
const countdownMenuMinutesUnit = document.createElement('span');
countdownMenuMinutesUnit.classList.add('countdown-unit');
const countdownMenuSecondsUnit = document.createElement('span');
countdownMenuSecondsUnit.classList.add('countdown-unit');

countdownMenuDays.append(countdownMenuDaysValue, ' ', countdownMenuDaysUnit);
countdownMenuHours.append(countdownMenuHoursValue, ' ', countdownMenuHoursUnit);
countdownMenuMinutes.append(countdownMenuMinutesValue, ' ', countdownMenuMinutesUnit);
countdownMenuSeconds.append(countdownMenuSecondsValue, ' ', countdownMenuSecondsUnit);

countdownMenuTimer.append(
  countdownMenuDays,
  countdownMenuHours,
  countdownMenuMinutes,
  countdownMenuSeconds
);

// TO-DO: uncomment for countend timer for crowdfunding
// document.querySelector('#header-navigation ul').append(countdownMenuBanner);

/**
 * Updates the countdown timer with the given duration.
 *
 * @param {number} millis number of milliseconds in duration
 */
function updateDHMS(millis) {
  millis /= 1000;
  const seconds = Math.max(Math.floor(millis % 60), 0);
  millis /= 60;
  const minutes = Math.max(Math.floor(millis % 60), 0);
  millis /= 60;
  const hours = Math.max(Math.floor(millis % 24), 0);
  millis /= 24;
  const days = Math.max(Math.floor(millis), 0);

  countdownMenuDaysValue.innerText = days.toString().padStart(2, 0);
  countdownMenuDaysUnit.innerText = days !== 1 ? 'days' : 'day';

  countdownMenuHoursValue.innerText = `:${hours.toString().padStart(2, 0)}`;
  countdownMenuHoursUnit.innerText = hours !== 1 ? 'hours' : 'hour';

  countdownMenuMinutesValue.innerText = `:${minutes.toString().padStart(2, 0)}`;
  countdownMenuMinutesUnit.innerText = minutes !== 1 ? 'mins' : 'min';

  countdownMenuSecondsValue.innerText = `:${seconds.toString().padStart(2, 0)}`;
  countdownMenuSecondsUnit.innerText = seconds !== 1 ? 'secs' : 'sec';
}

/**
 * Updates the countdown on the page.
 *
 * @param {number?} countdownHandle the handle to the countdown updater interval
 */
function updateCountdown(countdownHandle) {
  const now = Date.now();
  if (now >= countdownClose) {
    // countdownMenuTitle.innerText = 'Applications closed!';
    countdownMenuTitle.innerText = 'Crowdfunding closed!';
    countdownMenuTitle.className = 'closed';
    updateDHMS(countdownClose - now);
    clearInterval(countdownHandle);
  } else if (now >= countdownOpen) {
    // countdownMenuTitle.innerText = 'Applications close in';
    countdownMenuTitle.innerText = 'Crowdfunding ends in';
    countdownMenuTitle.className = 'open';
    updateDHMS(countdownClose - now);
  } else {
    // countdownMenuTitle.innerText = 'Applications open in';
    countdownMenuTitle.innerText = 'Crowdfunding starts in';
    countdownMenuTitle.className = 'pre-open';
    updateDHMS(countdownOpen - now);
  }
}

if (Date.now() >= countdownStart) {
  updateCountdown();

  const countdownHandle = setInterval(() => {
    updateCountdown(countdownHandle);
  }, 1000);
}
